export class Session {
  static readonly type = '[Auth] Session';
}

export class Register {
  static readonly type = '[Auth] Register';

  constructor(public params: any) {
  }
}

export class Start {
  static readonly type = '[Auth] Start';
}

export class Login {
  static readonly type = '[Auth] Login';

  constructor(public params: { username: string, password: string, obSSOCookie: string }, public register: any) {
  }
}

export class Profile {
  static readonly type = '[Auth] Profile';
}

export class CookieAuth {
  static readonly type = '[Auth] CookieAuth';

  constructor(public params: { check: Boolean }) {
  }
}

export class SwitchItem {
  static readonly type = '[Auth] SwitchItem';

  constructor(public item: { value: string, type: string }) {
  }
}

export class Logout {
  static readonly type = '[Auth] Logout';
}
